export default "__VITE_ASSET__BBlmbjQd__"